export const AuthorizationErrorReason = {
  ROLE_NOT_FOUND: 'ROLE_NOT_FOUND',
  ROLE_NAME_DUPLICATE: 'ROLE_NAME_DUPLICATE',
  ROLE_NAME_RESERVED_SYSTEM: 'ROLE_NAME_RESERVED_SYSTEM',
  MAX_CUSTOM_ROLES_EXCEEDED: 'MAX_CUSTOM_ROLES_EXCEEDED',
  ROLE_DELETION_REQUIRES_FALLBACK: 'ROLE_DELETION_REQUIRES_FALLBACK',
  FALLBACK_ROLE_NOT_ACCESSIBLE: 'FALLBACK_ROLE_NOT_ACCESSIBLE',
  FALLBACK_ROLE_SAME_AS_DELETED: 'FALLBACK_ROLE_SAME_AS_DELETED',
  INVALID_PERMISSION_KEYS: 'INVALID_PERMISSION_KEYS',
  SYSTEM_ROLE_IMMUTABLE: 'SYSTEM_ROLE_IMMUTABLE',
} as const;

export type AuthorizationErrorReason =
  (typeof AuthorizationErrorReason)[keyof typeof AuthorizationErrorReason];

const AUTHORIZATION_ERROR_REASON_SET = new Set<string>(
  Object.values(AuthorizationErrorReason),
);

export function isAuthorizationErrorReason(
  value: unknown,
): value is AuthorizationErrorReason {
  return typeof value === 'string' && AUTHORIZATION_ERROR_REASON_SET.has(value);
}
